import React, { useState, useEffect } from 'react';
import Button from './Button';
import ArrowUpIcon from './icons/ArrowUpIcon';
import { useTranslation } from 'react-i18next';

const BackToTopButton: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-20 right-4 z-30 print:hidden md:bottom-6 md:right-6">
      <Button onClick={scrollToTop} className={`!p-3 rounded-full shadow-lg transition-all duration-300 ease-in-out transform ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90 pointer-events-none'}`} title={t('backToTopButton.title')} aria-label={t('backToTopButton.title')} tabIndex={isVisible ? 0 : -1}>
        <ArrowUpIcon className="h-6 w-6" />
      </Button>
    </div>
  );
};

export default BackToTopButton;